import { IRechargeOrder } from "../model/RechargeOrder";
import { PropName } from "../types";

import { getProp } from "./properties";

export function isCheckout(order: Pick<IRechargeOrder, "type" | "line_items" | "note">): boolean {
  // For old orders, we check for type == checkout
  if (order.type === "checkout") {
    return true;
  }
  // For new checkouts, we check if the checkout property is set
  const hasCheckoutProp = order.line_items.some((li) => !!getProp(li.properties, PropName.IsCheckout, "true", true));
  if (hasCheckoutProp) {
    return true;
  }
  // As a fallback, we also consider the customer's first order to be a checkout
  const sequence = order.note?.match(/next order in sequence (\d+)/)?.at(1);
  if (sequence && Number.parseInt(sequence, 10) === 1) {
    return true;
  }
  // Else, it's not a checkout
  return false;
}
